import { useCallback, useState } from 'react';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { TableInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import moment from 'moment';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import { Grid, MenuItem } from '@mui/material';
import CustomSelect from '../../../../../components/common/SelectField';
import { convToTime } from '../../../../../utils/helpers';
import { TimePicker } from '@mui/x-date-pickers';
import React from 'react';
import SimpleSelect from '../../../../../components/common/SimpleSelect';

interface IProps {
  moduleData: any;
  isView: boolean;
  handleSumbit: any;
  handelDeleteRows: any;
  isOpenPopup: any;
  setIsOpenPopup: any;
  setPartIdx: any;
  machineData: any;
}

const TBody = ({
  moduleData,
  isView,
  handleSumbit,
  handelDeleteRows,
  isOpenPopup,
  setIsOpenPopup,
  setPartIdx,
  machineData,
}: IProps) => {
  const [render, setRender] = useState(false);
  const MemoizedCustomSelect = React.memo(CustomSelect);
  const handleSelectChange = useCallback(
    (e: any, check: any, index: any) => {
      check.days[index] = e.target.value;
      setRender((prev) => !prev);
    },
    [setRender],
  );

  return (
    <>
      <tbody>
        {moduleData &&
          moduleData.processes.map((process: any, index: number) => (
            <>
              <tr key={index + 'module data'}>
                <td
                  style={{ fontWeight: 'bold', minWidth: '50px' }}
                  rowSpan={4 + 1}
                >
                  {index + 1}
                </td>
                <td rowSpan={4 + 1} align="left" style={{ minWidth: '250px' }}>
                  <AutocompleteMuiCustom
                    id="Machine"
                    label=""
                    option_name="machine_no"
                    option_name_2="machine_name"
                    arrayofObj={machineData}
                    value={process.machine_id || ''}
                    onChange={(e, value) => {
                      process.machine_id = value;
                      setRender((prev) => !prev);
                    }}
                  />
                </td>
                <td colSpan={32} style={{ marginTop: '0px' }}></td>
                <td style={{ minWidth: '100px' }} rowSpan={4 + 1}>
                  <DeleteIconButton
                    tooltipTitle={'delete'}
                    onClick={() => handelDeleteRows(index)}
                  />
                </td>
              </tr>
              {process &&
                process?.checkpoints.map((check: any, checkIdx: any) => {
                  return (
                    <tr key={checkIdx + 'checkpoints'}>
                      <th style={{ minWidth: '250px' }}>{check?.checkpoint}</th>
                      {check?.days.map((day: any, dayIndex: any) => {
                        return (
                          <td
                            style={{ minWidth: '70px' }}
                            key={dayIndex + 'dayIndex'}
                          >
                            <SimpleSelect
                              name={`days[${dayIndex}]`}
                              value={check.days[dayIndex]}
                              onChange={(e: any) => {
                                check.days[dayIndex] = e.target.value;
                                setRender((prev) => !prev);
                              }}
                              values={[
                                { value: '', label: '' },
                                { value: '✓', label: '✓' },
                                { value: '⨯', label: '⨯' },
                              ]}
                              style={{
                                padding: '8px',
                                fontSize: '30px',
                                border: '3px solid white',
                                borderRadius: '50%',
                                cursor: 'pointer',
                                outline: 'none',
                                width: '70px',
                                backgroundColor: 'white',
                                color: 'black',
                              }}
                              optionStyle={{
                                backgroundColor: 'white',
                                color: 'black',
                                width: '40px',
                              }}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </>
          ))}
      </tbody>
    </>
  );
};

export default TBody;
